const styles = (theme) => ({
  radioRoot: {
    padding: theme.spacing(1),
  },
  labelRoot: {
    marginLeft: theme.spacing(-1),
  },
  icon: {
    height: 18,
    width: 18,
    borderRadius: '50%',
    border: `1px solid ${theme.color.grey_75}`,
  },
  checkedIcon: {
    height: 18,
    width: 18,
    borderRadius: '50%',
    border: `6px solid ${theme.color.black_11}`,
  },
  label: {},
});

export default styles;
